import { defineComponent, useTemplateRef, computed, openBlock, createElementBlock, unref, normalizeClass, renderSlot } from "vue";
import { u as useDefaults } from "./useDefaults-BTLXvYhO.mjs";
const _hoisted_1 = ["id", "novalidate"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "BForm",
  props: {
    floating: { type: Boolean, default: false },
    id: { default: void 0 },
    novalidate: { type: Boolean, default: false },
    validated: { type: Boolean, default: false }
  },
  setup(__props, { expose: __expose }) {
    const _props = __props;
    const props = useDefaults(_props, "BForm");
    const element = useTemplateRef("_element");
    const computedClasses = computed(() => ({
      "form-floating": props.floating,
      "was-validated": props.validated
    }));
    __expose({
      element
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("form", {
        id: unref(props).id,
        ref: "_element",
        novalidate: unref(props).novalidate,
        class: normalizeClass(computedClasses.value)
      }, [
        renderSlot(_ctx.$slots, "default")
      ], 10, _hoisted_1);
    };
  }
});
export {
  _sfc_main as _
};
//# sourceMappingURL=BForm.vue_vue_type_script_setup_true_lang-Crnxo4h0.mjs.map
